import { Mesh, PlaneGeometry, MathUtils } from 'three'

import BaseScene from '../core/BaseScene.js'
import BaseCamera from '../core/BaseCamera.js'
import { webgl } from '../core/GL.js'
import BackgroundMaterial from '@materials/BackgroundMaterial.js'

export default class HomeScene extends BaseScene {

    init() {
        super.init()

        this.camera = new BaseCamera()
        this.camera.base.position.z = 1

        this.material = new BackgroundMaterial()
        this.plane = new Mesh(new PlaneGeometry(1, 1), this.material)
        this.addObject3D(this.plane)

        this.resize()
    }


    getPlaneSizeAtZ(z, camera) {
        const fov = camera.fov
        const aspect = window.innerWidth / window.innerHeight
        const height = 2 * Math.tan(MathUtils.degToRad(fov / 2)) * z
        const width = height * aspect
        return { width, height }
    }


    update() {
        this.material.uniforms.u_time.value = webgl.$time.elapsed / 1000
    }


    render() {
        const renderer = webgl.$renderer.instance
        if (!renderer || !this.camera) return
        renderer.render(this.base, this.camera.base)
    }


    resize() {
        if (this.camera) this.camera.resize()

        this.material.uniforms.u_resolution.value.x = window.innerWidth
        this.material.uniforms.u_resolution.value.y = window.innerHeight

        const { width, height } = this.getPlaneSizeAtZ(this.camera.base.position.z, this.camera.base)
        this.plane.scale.set(width, height, 1)
    }

}
